import { render, staticRenderFns } from "./index.vue?vue&type=template&id=22be8111&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=22be8111&scoped=true&lang=css&"
import style1 from "./index.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22be8111",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22be8111')) {
      api.createRecord('22be8111', component.options)
    } else {
      api.reload('22be8111', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=22be8111&scoped=true&", function () {
      api.rerender('22be8111', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Admin/SecondaryUsers/index.vue"
export default component.exports